<template> 
    <span>{{fragment.text}}</span>  
</template>

<script>
export default {
  name: "fragment-label",
  props: ["fragment"]
};
</script>
 

<style scoped>
</style>